import React, { useState, useEffect } from "react";
import ChatBubble from "./ChatBubble";
import ChatBox from "./ChatBox";
import { getChatStatus } from "../api/chatApi";

const ChatWidget = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isChatbotEnabled, setIsChatbotEnabled] = useState(false);
    const [statusChecked, setStatusChecked] = useState(false);

    useEffect(() => {
        // Fetch chatbot status on mount
        const fetchStatus = async () => {
            try {
                const response = await getChatStatus();
                setIsChatbotEnabled(response.data.enabled || false);
            } catch (error) {
                console.warn("Failed to fetch chatbot status, hiding chat bubble:", error);
                setIsChatbotEnabled(false);
            } finally {
                setStatusChecked(true);
            }
        };

        fetchStatus();
    }, []);

    // Don't render anything until status is checked
    if (!statusChecked) {
        return null;
    }

    // Don't render if chatbot is disabled
    if (!isChatbotEnabled) {
        return null;
    }

    return (
        <div className="fixed bottom-0 right-0 z-50 font-roboto">
            {/* Chatbox - conditional render */}
            {isOpen && <ChatBox onClose={() => setIsOpen(false)} />}

            {/* Chat Bubble - only visible when chatbot is enabled */}
            <ChatBubble
                isOpen={isOpen}
                onClick={() => setIsOpen(!isOpen)}
            />
        </div>
    );
};

export default ChatWidget;
